<div>
    <!-- Action Buttons -->
    <div style="display: flex; justify-content: flex-end; gap: 10px; margin-bottom: 20px;" class="noPrint">
        <button id="print-button" mat-raised-button color="primary" style="display: none;"
            printSectionId="print-section" [useExistingCss]="true" ngxPrint>
            Print
        </button>

        <button (click)="print()" mat-raised-button color="primary">Print</button>
        <button (click)="exportExcel('Advt_Invoice_Register')" mat-raised-button color="primary">Export</button>
        <button mat-button mat-dialog-close>Close</button>
    </div>

    <!-- Printable Section -->
    <ng-container>
        <div class="container" id="print-section"
            style="padding: 20px; font-family: 'Mangal', 'Arial', sans-serif; font-size: 14px;">
            <!-- Header -->
            <div style="text-align: center; font-size: 20px; font-weight: bold;">
                विवेक <br />
                हिंदुस्थान प्रकाशन संस्था
            </div>
            <div style="text-align: center; font-size: 14px;">
                <br />
                ३०३, वडाळा उद्योग भवन, नायगाव क्रॉस रोड, वडाळा मुंबई ४०० ३०९
            </div>

            <!-- Info Row -->
            <table style="width: 100%; margin-top: 20px;">
                <tr style="font-size: 16px; margin-bottom: 10px;">
                    <td><strong>क्रमांक :</strong> {{ d_voucher_no }}</td>
                    <td> <span id="dbt-voucher"
                            style="text-align: center; border: 2px solid black; padding: 8px; border-radius: 20px;">
                            <strong>डेबिट व्हाऊचर</strong></span>
                    </td>
                    <td style="text-align: right;"><strong>दिनांक :</strong> {{ d_voucher_date }}</td>
                </tr>
                <tr style="font-size: 16px;">
                    <td><strong>खर्च कर्ता : </strong> {{ rep_name }}</td>
                    <td> <span></span></td>
                    <td style=" text-align: right;"><strong>{{ narration }}</strong></td>
                </tr>
            </table>
            <hr style="font-weight: bold;">
            <!-- Account Table -->
            <div class="container mt-3">
                <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
                    <thead>
                        <tr style="border: 1px solid black;">
                            <th style="text-align: left; padding: 10px;">मुख्य खाते</th>
                            <th style="text-align: left; padding: 10px;">उप खाते</th>
                            <th style="text-align: center; padding: 10px;">रक्कम (₹)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let expense of debitexpenses">
                            <td style="text-align: left; padding: 10px;">{{ expense.mainexpname }}</td>
                            <td style="text-align: left; padding: 10px;">{{ expense.subexpname || '-' }}</td>
                            <td style="text-align: center; padding: 10px;">{{ expense.expamt | number:'1.2-2' }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr style="border: 1px solid black;font-weight: bold;">
                            <td style="text-align: left; padding: 10px;">एकूण खर्च रक्कम : {{ getTotalExpenseAmt() |
                                number:'1.2-2' }}</td>
                            <td style="text-align: left; padding: 10px;"></td>
                            <td style="text-align: center;padding: 10px;"></td>
                        </tr>
                        <tr style="border: 1px solid black;">
                            <td style="text-align: left; padding: 10px;font-weight: bold;">अक्षरी रु : {{
                                getTotalInMarathiWords() }}</td>
                            <td style="text-align: left;padding: 10px;"></td>
                            <!-- <td style="text-align: right;">{{ getTotalExpense() | number:'1.2-2' }}</td> -->
                            <td style="text-align: center; padding: 10px;"></td>
                        </tr>
                    </tfoot>
                </table>
                <!-- Footer Signatures -->
                <table style="width: 100%; margin-top: 80px; text-align: center;font-weight: 300;font-size: 16px;">
                    <tr>
                        <td>लेखापाल</td>
                        <td>खजिनदार</td>
                        <td>व्यवस्थापक</td>
                        <td>रक्कम घेणाऱ्याची सही</td>
                    </tr>
                </table>
            </div>
        </div>
    </ng-container>
</div>